import { GridCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import styledComponent from 'styled-components';
import { colors } from 'styles/styleVariables';

/**
 * Cell renderer to display the text as blue `(colors.amnBlue)`
 * @param params X-Grid Params: `GridCellParams`
 * @returns JSXElement
 */
export const XGridClickableCell = (onModsDetailsClick: Function, isHoverView?: boolean) => (params: GridCellParams) => {
  return (
    <BlueName style={{ padding: isHoverView ? '8px' : '0px' }} onClick={() => onModsDetailsClick(params, 'single')}>
      {params.value}
    </BlueName>
  );
};

const BlueName = styledComponent.span`
  color: ${colors.amnBlue};cursor: pointer;font-size: 14px;letter-spacing:0.01071em;line-height:1.43;margin:0;font-family:"Roboto","Helvetica","Arial",sans-serif`;
